export default function dischargeArray(array, maxLength) {
  if (array.length <= maxLength) {
    return array;
  }

  const optimalFrequency = Math.ceil(array.length / (array.length - maxLength));

  return array.filter((v, i) => i % optimalFrequency === 1);
}
